<script>
  export let item;
</script>

<div class="aspect-w-3 aspect-h-2">
  <img class="object-cover shadow-md rounded-sm" src={item.src} alt={item.alt}>
</div>